import { render, staticRenderFns } from "./SortVariant.vue?vue&type=template&id=4d9db411&"
import script from "./SortVariant.vue?vue&type=script&lang=js&"
export * from "./SortVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports